import { Heading, Table, Text, Th, Thead, Tr } from '@chakra-ui/react';

export const ProductTableHeader = () => {
  return (
    <Thead>
      <Tr>
        <Th py="0">
          <Heading fontSize="xl" fontWeight="bold">
            Rincian Produk
          </Heading>
        </Th>
        <Th py="0">
          <Text textColor="gray.75" fontWeight="600">
            Jumlah{' '}
          </Text>
        </Th>
        <Th py="0">
          <Text textColor="gray.75" fontWeight="600">
            Harga{' '}
          </Text>
        </Th>
        <Th py="0">
          <Text textColor="gray.75" fontWeight="600">
            Total Harga
          </Text>
        </Th>
      </Tr>
    </Thead>
  );
};
